import { render, staticRenderFns } from "./ReadMore.vue?vue&type=template&id=b09cdada&"
import script from "./ReadMore.vue?vue&type=script&lang=js&"
export * from "./ReadMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b09cdada')) {
      api.createRecord('b09cdada', component.options)
    } else {
      api.reload('b09cdada', component.options)
    }
    module.hot.accept("./ReadMore.vue?vue&type=template&id=b09cdada&", function () {
      api.rerender('b09cdada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/lib/vue/components/modules/ReadMore.vue"
export default component.exports